import * as actions from './baseActions';
import { state, mutations } from './baseMutations';

export default {
  actions,
  state,
  mutations,
};